<script>
import { EpisodePageElementMixin } from "%/dynamic-component-editor/standard-pages/episode-page/episode-page-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import { CountElementMixin }
  from "%/dynamic-component-editor/standard-elements/text-element/count-element-mixin";

export default {
  name: "EpisodeLikeCount",
  elementPanelSettings: {
    displayName: "Like Count",
    displayIcon: "solar:like-bold",
    elementGroup: "episode",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [EpisodePageElementMixin, CountElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.formattedCount(this.entity.likeCount);
    },
  },
};
</script>
